<table
  class="comp table-striped borderless"
  width="100%"
  cellspacing="0"
  border="0"
  (mouseleave)="rowHovered(null)"
>
  <tbody>
    <tr
      *ngFor="let school of values(schools); let i = index"
      [ngClass]="{ hoveredRow: fixedColRowHoveredIndex == i }"
      (mouseover)="rowHovered(i)"
    >
      <td
        *ngFor="let column of columns; let first = first; let j = index"
        class="comp comp-value"
      >
        <div *ngIf="school[column.id]">
          <span
            [ngStyle]="{
              color: school[column.id] ? school[column.id].color : ''
            }"
            class="comp-overall-value"
            [tooltip]="valueTooltip"
            [placement]="
              j === columns.length - 1 && i === 0
                ? 'left'
                : j === columns.length - 1
                ? 'left'
                : i < values(schools).length - 2
                ? 'bottom'
                : 'top'
            "
            container="body"
          >
            {{ district[column.id] ? district[column.id].overallPrefix : ""
            }}{{
              district[column.id] &&
              district[column.id]["roundTo"] !== undefined
                ? (school[column.id].y
                  | number
                    : "1." +
                        district[column.id]["roundTo"] +
                        "-" +
                        district[column.id]["roundTo"])
                : (school[column.id].y | number)
            }}{{ district[column.id] ? district[column.id].overallSuffix : "" }}
          </span>
        </div>
        <img
          [src]="'../assets/images/no_data.png'"
          *ngIf="school[column.id] == null"
          class="no-data-image-comp"
          alt="No data available!"
          [tooltip]="valueTooltip"
          [placement]="
            j === columns.length - 1 && i === 0
              ? 'left'
              : j === columns.length - 1
              ? 'left'
              : i < values(schools).length - 2
              ? 'bottom'
              : 'top'
          "
          container="body"
        />
        <ng-template #valueTooltip>
          <value-tooltip
            [school]="school"
            [district]="district"
            [column]="column"
          ></value-tooltip>
        </ng-template>
      </td>
    </tr>
  </tbody>
</table>
